import MuiBottomNavigationAction from '@material-ui/core/BottomNavigationAction';

export default MuiBottomNavigationAction;
